import React, { useState, useMemo } from 'react'
import { formatFirebaseTimestamp, timestampToMillis } from '../../utils/datetime'
import CommunityDetailModal from '../components/CommunityDetailModal';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export default function Communities({ communities, toggleConfirmDialog }) {

    const [detailCommunity, setDetailCommunity] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortDesc, setSortDesc] = useState(true);

    const filteredCommunities = useMemo(() => {
        const query = searchQuery.toLowerCase().trim();
        const filtered = !query ? communities : communities.filter(c =>
            c?.id?.toLowerCase().includes(query) ||
            c?.name?.toLowerCase().includes(query)
        );
        return [...filtered].sort((a, b) => {
            const diff = timestampToMillis(a?.createdAt) - timestampToMillis(b?.createdAt);
            return sortDesc ? -diff : diff;
        });
    }, [communities, searchQuery, sortDesc]);

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '16px' }}>

            <div className="users-search-container">
                <SearchIcon sx={{ color: '#6c757d', fontSize: '20px' }} />
                <input
                    type="text"
                    placeholder="Search by ID or name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="users-search-input"
                />
                {searchQuery && (
                    <ClearIcon
                        sx={{ color: '#adb5bd', fontSize: '18px', cursor: 'pointer', '&:hover': { color: '#6c757d' } }}
                        onClick={() => setSearchQuery('')}
                    />
                )}
            </div>

            <table className="request-table">
                <thead>
                    <tr className="request-row" style={{ backgroundColor: 'var(--color-primary)' }}>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Open</th>
                        <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => setSortDesc(d => !d)}>
                            createdAt {sortDesc ? '▼' : '▲'}
                        </th>
                        <th>createdBy</th>

                        <th style={{ textAlign: 'end' }}>*</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredCommunities.length === 0 ? (
                        <tr><td colSpan="5"><p>{searchQuery ? 'No communities match your search' : 'No communities'}</p></td></tr>
                    ) : filteredCommunities.map((community, index) => {
                        return (
                            <tr key={index} className="request-row" style={{ cursor: 'pointer' }} onClick={() => setDetailCommunity(community)}>
                                <td>{community?.id}</td>
                                <td>{community?.name}</td>
                                <td>{community?.open ? 'Yes' : 'No'}</td>



                                <td>{formatFirebaseTimestamp(community?.createdAt)}</td>
                                <td>{community?.createdBy}</td>

                          
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            {detailCommunity && (
                <CommunityDetailModal
                    community={detailCommunity}
                    onClose={() => setDetailCommunity(null)}
                />
            )}
        </div>)
}